import { Role  } from '../../Helpers/AuthorizationDataProvider';

export interface RegistrationApplicantData {
	acceptedTac: boolean
	email: string
	firstName: string
	lastName: string
	location: string
	role: 'Mentee'
}

export interface RegistrationMenteeData {
	acceptedTac: boolean
	email: string
	firstName: string
	includeInNetwork: boolean
	includeInSearch: boolean
	lastName: string
	location: string
	password: string
	previousLnlm: string
	payload: {
		MenteeApplication: {}
	}
	role: 'Mentee'
}

export interface RegistrationMentorData {
	acceptedTac: boolean
	email: string
	firstName: string
	includeInNetwork: boolean
	includeInSearch: boolean
	lastName: string
	location: string
	password: string
	previousLnlm: string
	payload: {
		MentorApplication: {
			acceptedCoc: boolean
			currentPosition: string
			institution: string
			languages: string[]
			location: string
			mentoringScopes: string[]
			motivation: string
			researchAreas?: string[]
			startDate: string
		}
	}
	role: 'Mentor'
}

export interface ApplicantFormData {
	acceptedTac: boolean
	currentLocation: string
	email: string
	firstName: string
	lastName: string
	role: Role
}

export interface MenteeFormData extends ApplicantFormData {
	includeInNetwork: boolean
	includeInSearch: boolean
	password: string
	passwordConfirm: string
	previousLnlm: string
}

export interface MentorFormData extends MenteeFormData {
	acceptedCoc: boolean
	currentPosition: string
	institution: string
	languages: string[]
	location: string
	mentoringScopes: string[]
	motivation: string
	researchAreas: string[]
	startDate: Date
}

export interface ValidStep {
	[key: string]: boolean
}

export enum PasswordStrength {
	Strong = 'strong',
	Medium = 'medium',
	Weak = 'weak',
}

export interface Meeting {
	date: string | Date
	id: string
	name: string
}

export interface MeetingsResponse {
	count: number
	conferences: Meeting[]
}

